<div class="employee-basket-cart-archive">
  @if (isLoading()) {
    <div class="employee-basket-cart-archive__loader">
      <flexyoo-loader></flexyoo-loader>
    </div>
  } @else if (shouldGroup()) {
    @for (group of statusGroups(); track group.kind) {
      <section class="employee-basket-card employee-basket-cart-archive__group">
        <mat-expansion-panel class="employee-basket-cart-archive__group-panel">
          <mat-expansion-panel-header>
            <mat-panel-title
              class="employee-basket-cart-archive__group-title"
              [style.color]="group.statusColor"
            >
              {{ group.statusTranslationKey | translate | uppercase }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          @for (cart of group.carts; track cart.Id) {
            <flexyoo-employee-basket-cart-archive-item
              [cart]="cart"
              (signBenefit)="onSignBenefit($event)"
              (signCart)="onSignCart($event)"
            />
          }
        </mat-expansion-panel>
      </section>
    }
  } @else {
    @for (cart of carts(); track cart.Id) {
      <flexyoo-employee-basket-cart-archive-item
        [cart]="cart"
        (signBenefit)="onSignBenefit($event)"
        (signCart)="onSignCart($event)"
      />
    }
  }
</div>
